import * as actionTypes from './actionTypes';

export const setETID = (payload: any) => ({
    type: actionTypes.SET_ETID,
    payload,
});

export const setForeign = (payload: any) => ({
    type: actionTypes.SET_FOREIGN,
    payload,
});

export const setLanguage = (payload: any) => ({
    type: actionTypes.SET_LANGUAGE,
    payload,
});

export const setCurrency = (payload: any) => ({
    type: actionTypes.SET_CURRENCY,
    payload,
});

export const setIsLogin = (payload: any) => ({
    type: actionTypes.SET_ISLOGIN,
    payload,
});

export const setIsDisney = (payload: any) => ({
    type: actionTypes.SET_ISDISNEY,
    payload,
});

export const setIsGDS = (payload: any) => ({
    type: actionTypes.SET_ISGDS,
    payload,
});

export const setIsErpOrder = (payload: any) => ({
    type: actionTypes.SET_ISERPORDER,
    payload,
});

export const setFocusArea = (payload: any) => ({
    type: actionTypes.SET_FOCUSAREA,
    payload,
});

export const setListStatus = (payload: any) => ({
    type: actionTypes.SET_LISTSTATUS,
    payload,
});

export const setListData = (payload: any) => ({
    type: actionTypes.SET_LISTDATA,
    payload,
});

// export const setDetailFetchData = (payload: any) => ({
//     type: actionTypes.SET_DETAILFETCHDATA,
//     payload,
// });

export const setDetailFetchAllData = (payload: any) => ({
    type: actionTypes.SET_DETAILFETCHALLDATA,
    payload,
});

export const setDetailFetchMonths = (payload: any) => ({
    type: actionTypes.SET_DETAILFETCHMONTHS,
    payload,
});

export const setDetailFetchFailMsg = (payload: any) => ({
    type: actionTypes.SET_DETAILFETCHFAILMSG,
    payload,
});

export const setVerificationStatus = (payload: any) => ({
    type: actionTypes.SET_VERIFICATIONSTATUS,
    payload,
});

export const setProductDescKey = (payload: any) => ({
    type: actionTypes.SET_PRODUCTDESCKEY,
    payload,
});

// 自建
export const setIsTDetailCrossLoading = (payload: any) => ({
    type: actionTypes.SET_ISTDETAILCROSSLOADING,
    payload,
});

// GDS
export const setGListData = (payload: any) => ({
    type: actionTypes.SET_GLISTDATA,
    payload,
});

export const setGDetailStore = (payload: any) => ({
    type: actionTypes.SET_GDETAILSTORE,
    payload,
});